// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#panel[data-v-67f82299] {\n  border: 5px double var(--v-panel-border-base) !important;\n  border-radius: 2px !important;\n}\n", ""]);
// Exports
module.exports = exports;
